import React from 'react';
import { useTranslation } from 'react-i18next';
import './TeensDetailedDescription.css';   
import LeftElement from './../../assets/Images/teens/3.png';

const TeensDetailedDescription: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="teens-overview-container">
      {/* Stats Section */}
      <div className="teens-overview-stats">
        <div className="teens-stat-item">
          <span className="teens-stat-value">{t("teens_stat_character")}</span> {t("teens_stat_character_desc")}
        </div>
        <div className="teens-stat-item">
          <span className="teens-stat-value">{t("teens_stat_brain")}</span> {t("teens_stat_brain_desc")}
        </div>
        <div className="teens-stat-item">
          <span className="teens-stat-value">{t("teens_stat_mindset")}</span> {t("teens_stat_mindset_desc")}
        </div>
        <div className="teens-stat-item">
          <span className="teens-stat-value">{t("teens_stat_mindset2")}</span> {t("teens_stat_mindset_desc2")}
        </div>
      </div>

      {/* About Section */}
      <div className="teens-about-section">
        <img src={LeftElement} alt="l" className="left-element-teens-about" />
        <div>
          <h1 className='About-teens-H1'>{t("teens_about_title2")}</h1>
          <p className='About-teens-p'>{t("teens_about_paragraph1")}</p>
          <p className='About-teens-p'>
            {t("teens_about_paragraph2_1")} 
            <span className='About-teens-p-bold'>{t("teens_about_highlight1")}</span>,
            {t("teens_about_paragraph2_2")} 
            <span className='About-teens-p-bold'>{t("teens_about_highlight2")}</span>, 
            {t("teens_about_paragraph2_3")}
            <span className='About-teens-p-bold'>{t("teens_about_highlight3")}</span>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeensDetailedDescription;
